import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { loginRequest } from '~/store/modules/auth/actions';
// Importando componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container } from './styles';

export default function Login() {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [carregar, setCarregar] = useState(false);

  async function handleSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        email: Yup.string()
          .email('Preencha um e-mail valido.')
          .required('Preencha o campo email.'),
        password: Yup.string().required('Preencha o campo senha.'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      dispatch(loginRequest(data.email, data.password));
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <Form ref={inputRef} onSubmit={handleSubmit} autoComplete="off">
        <Input icon="MdMail" name="email" label="E-mail" type="text" />
        <Input icon="MdLock" name="password" label="Senha" type="password" />
        <Button size="100%" load={carregar}>
          Entrar
        </Button>
      </Form>
      <Link to="/recuperar">Esqueceu sua senha?</Link>
    </Container>
  );
}
